import React from "react";
import "../../HowItWorks/CallToActionSection/CallToActionSection.css"

const style =  {
  fontWeight: 700,
  color: '#df8d44'
}

const CallToActionSection = () => {
  return (
    <section className="_cTASectCont_x1A_" style={{marginTop:"5.3rem"}}>
      <div className="_cTASectContent_y2B_">
        <h2 className=" _hTitle_s5E_ features-title" style={{marginBottomBottom:"20rem"}}>
        Still Need Help?
        </h2>
        <p
          className=" workflow-subtitle _hSubtitle_t6F1_ _cDesc_y4D_ "
          style={{ paddingTop: "0px", marginTop: "0px",paddingBottom: "0px", marginBottom: "2rem", width:"100%",paddingLeft:"0",paddingRight:"0" }}
        >
          {/*  For urgent or confidential concerns, call*/}
          {/*<strong style={style}> &nbsp;+91 99999 99999</strong><br/> or email*/}
          <strong style={style} > &nbsp;support@vanidya.com</strong>.<br />
          We're committed to fair, fast and friendly support for every partner.
        </p>
        <div className="_cTAButtonsWrapper_b5E_">
          <a href="/contact" className="_cTAButton_c6F_ _devotee_d7G_">
        Contact Support
          </a>

    
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
